module.exports = __webpack_public_path__ + "img/gif.341a94e5.svg";